import { render, staticRenderFns } from "./LanguagesForm.vue?vue&type=template&id=26619c33&scoped=true&"
import script from "./LanguagesForm.vue?vue&type=script&lang=ts&"
export * from "./LanguagesForm.vue?vue&type=script&lang=ts&"
import style0 from "./LanguagesForm.vue?vue&type=style&index=0&id=26619c33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26619c33",
  null
  
)

export default component.exports